import React, { useEffect, useState } from 'react';

const LoadingState = ({ 
  message = 'Loading...',
  fullScreen = false,
  size = 'medium',
  className = ''
}) => {
  const [isVisible, setIsVisible] = useState(true);
  
  // Add a cleanup effect to ensure proper unmounting
  useEffect(() => {
    setIsVisible(true);
    return () => setIsVisible(false);
  }, []);
  
  const sizeClasses = {
    small: 'w-4 h-4',
    medium: 'w-8 h-8',
    large: 'w-12 h-12'
  };

  const spinnerSize = sizeClasses[size] || sizeClasses.medium;
  
  if (!isVisible) return null;
  
  if (fullScreen) {
    return (
      <div className="fixed inset-0 bg-white dark:bg-slate-900 bg-opacity-75 dark:bg-opacity-75 flex items-center justify-center z-50 transition-opacity duration-300">
        <div className="text-center">
          <svg className={`${spinnerSize} animate-spin text-primary mx-auto`} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          {message && <p className="mt-3 text-sm text-gray-700 dark:text-gray-300">{message}</p>}
        </div>
      </div>
    );
  }
  
  return (
    <div className={`flex items-center justify-center p-4 transition-opacity duration-300 ${className}`}>
      <div className="text-center">
        <svg className={`${spinnerSize} animate-spin text-primary mx-auto`} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        {message && <p className="mt-2 text-sm text-gray-700 dark:text-gray-300">{message}</p>}
      </div>
    </div>
  );
};

export default LoadingState; 